export type ThemePref = "light" | "dark" | "system";
const KEY = "modila:theme";
export function getThemePref(): ThemePref {
  try { const v = localStorage.getItem(KEY); if (v === "light" || v === "dark" || v === "system") return v; } catch { /* ignore */ }
  return "dark";
}
export function applyTheme(pref: ThemePref): void {
  const dark = pref === "dark" || (pref === "system" && matchMedia("(prefers-color-scheme: dark)").matches);
  document.documentElement.dataset.theme = dark ? "dark" : "light";
  document.documentElement.dataset.themePref = pref;
}
export function setThemePref(pref: ThemePref): void {
  try { localStorage.setItem(KEY, pref); } catch { /* ignore */ }
  applyTheme(pref);
}
export function watchSystemTheme(): void {
  matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => { if (getThemePref() === "system") applyTheme("system"); });
}
